export const HOUSING_CATEGORIES = ["House", "Dormitory"];

export const slotForCategory = (category) =>
  category === "House" ? "house" : "dormitory";

// Assigned responses contain one row per slot; lists and pickers need one student.
export function studentsFromAssignments(assignments) {
  const students = new Map();
  assignments.forEach((assignment) => {
    const key = String(assignment.studentID);
    const student = students.get(key) || {
      ...assignment,
      house: null,
      dormitory: null,
    };
    if (HOUSING_CATEGORIES.includes(assignment.category)) {
      student[slotForCategory(assignment.category)] = {
        id: assignment.accomodationID,
        name: assignment.accomodationName,
      };
    }
    students.set(key, student);
  });
  return Array.from(students.values());
}

export function venueOptions(venues, category, currentId) {
  return venues
    .filter((venue) => venue.category === category)
    .map((venue) => ({
      value: venue.id,
      label:
        category === "House"
          ? venue.name
          : `${venue.name} — ${venue.remainingSpace} spaces remaining`,
      disabled:
        category === "Dormitory" &&
        Number(venue.remainingSpace) <= 0 &&
        String(venue.id) !== String(currentId),
    }));
}

export function changedAllocations(student, selections) {
  return HOUSING_CATEGORIES.filter(
    (category) => category === "House" || student?.dayBoarding === "Boarding",
  )
    .map((category) => ({ category, slot: slotForCategory(category) }))
    .filter(
      ({ slot }) =>
        selections[slot] != null &&
        String(selections[slot]) !== String(student?.[slot]?.id),
    )
    .map(({ category, slot }) => ({
      category,
      slot,
      accomodationID: selections[slot],
    }));
}
